import React from 'react';
import icons from '../../../markons/markons';
import css from './insights.less';
import ActionLink from '../ActionLink';
import Icon from '../Icon';

interface YearControlProps {
    changeYear: (years:number)=>void
    year: null|number
}

export default function YearControl({changeYear, year}: YearControlProps) {
    return (
        <div className={css.yearControls}>
            <ActionLink className="btn btn-default" onClick={() => changeYear(-1)}><Icon name={icons.ionArrowLeftB}/>
                Prev</ActionLink>
            <span className={css.displayYear}>{year == null ? "All Time" : year}</span>
            <ActionLink className="btn btn-default" onClick={() => changeYear(1)}>Next
                <Icon name={icons.ionArrowRightB}/></ActionLink>
        </div>
    )
}
